export const isSameRange = (a, b) => {
    if (!a || !b) return false;

    return (
        a.startDate?.getTime() === b.startDate?.getTime() &&
        a.endDate?.getTime() === b.endDate?.getTime()
    );
};

export const getTodayRange = () => {
    const today = new Date();
    const d = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    return { startDate: d, endDate: d };
};

export const getYesterdayRange = () => {
    const today = new Date();
    const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    return { startDate: yesterday, endDate: yesterday };
};

export const getThisWeekRange = (weekStartsOn = 0, futureLimitDate = null) => {
    const today = new Date();
    const start = new Date(today);
    const diff = (today.getDay() - weekStartsOn + 7) % 7;
    start.setDate(today.getDate() - diff);

    const naturalEnd = new Date(start);
    naturalEnd.setDate(start.getDate() + 6);

    let end;

    if (!futureLimitDate) {
        end = naturalEnd;
    } else {
        end =
            naturalEnd.getTime() > futureLimitDate.getTime()
                ? futureLimitDate
                : naturalEnd;
    }

    return {
        startDate: new Date(start.getFullYear(), start.getMonth(), start.getDate()),
        endDate: new Date(end.getFullYear(), end.getMonth(), end.getDate())
    };
};

export const getLastWeekRange = (weekStartsOn = 0) => {
    const thisWeek = getThisWeekRange(weekStartsOn);
    const start = new Date(thisWeek.startDate);
    start.setDate(start.getDate() - 7);

    const end = new Date(start);
    end.setDate(start.getDate() + 6);

    return {
        startDate: new Date(start.getFullYear(), start.getMonth(), start.getDate()),
        endDate: new Date(end.getFullYear(), end.getMonth(), end.getDate())
    };
};

export const getThisMonthRange = (futureLimitDate = null) => {
    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth(), 1);

    const naturalEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    let end;

    if (!futureLimitDate) {
        end = naturalEnd;
    } else {
        end =
            naturalEnd.getTime() > futureLimitDate.getTime()
                ? futureLimitDate
                : naturalEnd;
    }

    return {
        startDate: start,
        endDate: new Date(end.getFullYear(), end.getMonth(), end.getDate())
    };
};

export const getLastMonthRange = () => {
    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const end = new Date(today.getFullYear(), today.getMonth(), 0);

    return { startDate: start, endDate: end };
};